import AdminTools from '../../assets/admin-tools.svg';
import ArtificialIntelligence from '../../assets/artificial-intelligence-collection.svg';
import AtlassianRovo from '../../assets/atlassian-rovo-collection.svg';
import ContentComms from '../../assets/content-comms.svg';
import DataAnalysis from '../../assets/data-analysis.svg';
import ProjectManagement from '../../assets/project-management.svg';
import RunsOnAtlassian from '../../assets/runs-on-atlassian.svg';
import SoftwareDevelopment from '../../assets/software-development.svg';
export const collections = [{
  id: 'artificial-intelligence',
  title: 'Artificial intelligence',
  description: 'Elevate productivity with AI-powered apps to revolutionize your workflows.',
  image: ArtificialIntelligence
}, {
  id: 'atlassian-rovo',
  title: 'Atlassian Rovo',
  description: 'Dive into an innovative app experience with apps enhanced by Rovo Agents.',
  image: AtlassianRovo
}, {
  id: 'project-management',
  title: 'Project Management',
  description: 'Streamline, manage, and track project phases.',
  image: ProjectManagement
}, {
  id: 'software-development',
  title: 'Software Development',
  description: 'Code, collaborate, and plan across every stage of the DevOps cycle.',
  image: SoftwareDevelopment
}, {
  id: 'content-communication',
  title: 'Content & Communication',
  description: 'Enhance communication with tools designed to efficiently share information and documentation among teams.',
  image: ContentComms
}, {
  id: 'data-analytics',
  title: 'Data & Analytics',
  description: 'Unlock valuable insights with data visualization and analytics tools.',
  image: DataAnalysis
}, {
  id: 'admin-tools',
  title: 'Admin Tools',
  description: 'Manage users, security, and settings with apps for admins.',
  image: AdminTools
}];
export const roaCollection = {
  id: 'runs-on-atlassian',
  title: 'Runs on Atlassian',
  description: 'Explore apps that run on Atlassian infrastructure, with data securely stored in-platform.',
  image: RunsOnAtlassian
};
export const bundlesCollection = {
  id: 'bundles',
  title: 'App bundles',
  description: 'Discover curated collections of apps to help you achieve your goals.',
  image: ArtificialIntelligence
};